import Header from "../components/layout/Header";
import portada from "../assets/portada.png";
import peso from "../assets/peso.png";
import llanta from "../assets/llanta.png";
import cart from "../assets/cart.png";
import Whatsapp from "../assets/Whatsapp.svg"
import Footer from "../components/layout/Footer";
import { useTitle } from "../hooks/useTitle";
import { useProductos } from "../hooks/useProductos";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import CarritoCompras from "../components/CarritoCompras";
import { Helmet } from "react-helmet-async";
import styles from './ProductList.module.css';

import { routes } from "../helpers/Routes";
import { useLocation } from "react-router-dom";
import CardBike from "../components/CardBike";
import { WhatsAppButton } from "../components/ui/WhatsAppbutton";
import { useHome } from "../contexts/HomeContext";

const Productos = () => {
    const [openCart, setOpenCart] = useState(false);
    const {  formatoCOP } = useProductos();
    const { bicycles, scooters} = useHome()
    const { pathname, hash } = useLocation()

    useEffect(() => {
        if (hash === '#scooters') {
            const element = document.getElementById('scooters');
            if (element) {
                // Timeout to ensure the element is rendered before scrolling
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    const handlePrev = () => {
        setCurrentTranslate((prev) => {
            const nextTranslate = prev + (cardWidth + gap);
            return Math.min(nextTranslate, 0); // Evita desplazarse más allá del inicio
        });
    };

    const handleNext = () => {
        setCurrentTranslate((prev) => {
            const nextTranslate = prev - (cardWidth + gap);
            return Math.max(nextTranslate, maxTranslate); // Evita desplazarse más allá del final
        });
    };

    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [currentProduct, setCurrentproduct] = useState(null);
    const handleMouseEnter = (index, producto) => {
        setHoveredIndex(index);
        setCurrentproduct(producto)
    };

    const handleMouseLeave = () => {
        setHoveredIndex(null);
        setCurrentproduct(null)
    };


    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <title>Bicletas Java Colombia</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Bicicletas de ruta | Bicicletas java colombia" />
                <meta property="og:url" content="https://bicicletasjavacolombia.com/" />
                <meta property="og:image" content="https://bicicletasjavacolombia.com/src/assets/logo-footer.png" />
                <meta property="og:description" content="Aquí encontrarás bicicletas bien equipadas, aerodinámicas, con marcos aprobados por la UCI y a un precio razonable. Java bicicletass ofrece bicicletas para todos.
                            Desde e-bikes y bicicletas de carretera de alto rendimiento hasta MTB y modelos urbanos diseñados para la movilidad diaria. También cuenta con una línea especial para niños, creada para acompañarlos en cada etapa de su crecimiento.
                            Con opciones de personalización, innovación y diseño de alta calidad, Java Bikes se posiciona como la compañera ideal para cualquier aventura." />
            </Helmet>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <div className="banner-productos">
                    <div className="portada">
                        <img src={portada} />
                        <p>Nuestros productos</p>
                    </div>
                </div>
                <div className="wrapper" style={{ backgroundColor: "#F0F0EC", width: "100%", maxWidth: "100%", color: "black" }}>
                    <div className="info-portada">
                        <h2>Nuestra gama de bicicletas</h2>
                        <p style={{ color: "black" }}>Bicicletas Java Colombia tiene opciones para todos: desde rutas hasta MTB. Con diseño innovador, calidad superior y personalización, son perfectas para cualquier aventura o trayecto diario.</p>
                    </div>
                </div>
                <div className="wrapper" style={{ marginTop: "40px", marginBottom: "40px" }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div className="products-bike-container-grid">

                            {bicycles?.map((producto, index) => {
                                const images = typeof producto?.img === "string" ? JSON.parse(producto?.img) : producto?.img;
                                return (
                                    <CardBike key={index} producto={producto} type="bike" formatoCOP={formatoCOP}></CardBike>
                                )
                            })}
                        </div>

                    </div>
                </div>

            <div className="wrapper" id="scooters" style={{ backgroundColor: "#F0F0EC", width: "100%", maxWidth: "100%", color: "black" }}>
                    <div className="info-portada">
                        <h2>Nuestra gama de Patinetas</h2>
                        <p style={{ color: "black" }}>Explora la ciudad con estilo y libertad. Nuestros scooters  ofrecen soluciones para todos los trayectos: desde recorridos urbanos hasta desplazamientos más exigentes. Con diseño innovador, calidad superior y opciones de personalización, son ideales para cualquier aventura o rutina diaria.</p>
                    </div>
                </div>
                <div className="wrapper" style={{ marginTop: "40px", marginBottom: "40px" }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div className="products-bike-container-grid">

                            {scooters?.map((producto, index) => {
                                const images = typeof producto?.img === "string" ? JSON.parse(producto?.img) : producto?.img;
                                return (
                                    <CardBike key={index} producto={producto} type="scooter" formatoCOP={formatoCOP}></CardBike>
                                )
                            })}
                        </div>

                    </div>
                </div>

                <Footer />
                <WhatsAppButton />
            </div>
        </>
    );
}

export default Productos;



